import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CallHistoryService } from '../../call-history.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { getCallHistoryPageSelector } from '../../call-history.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { UserSimplified } from '../../../contacts/shared/models/Contact';
import { CallHistorySearchParams } from '../../call-history-params.interface';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.scss']
})
export class UsersFilterComponent implements OnInit {
  @Input() users: UserSimplified[];
  @Input() label: any;
  @Output() toggleSelectAllUsers = new EventEmitter();
  @Input() allUsersSelected: boolean;
  public indeterminate: boolean;
  @ViewChild('usersSelector') usersSelector: MatSelect;
  public filters: CallHistorySearchParams;
  public selectedUsersForm = new FormControl();
  public displayLabel = '';

  constructor(public callHistoryService: CallHistoryService, private store: Store<IState>) {}

  ngOnInit() {
    // const activeUsers = this.users.filter(item => item.state === 'ACTIVE');
    // const unassigned = this.users.filter(item => item.id === -1);
    // const usersAvailableToSelect = activeUsers.concat(unassigned);
    this.store.select(getCallHistoryPageSelector).subscribe(params => {
      const selectedUsers =
        this.users && params.agentIds
          ? this.users.filter(item => {
              return params.agentIds.includes(item.id);
            })
          : [];

      const ids = selectedUsers.map(i => i.id);
      this.selectedUsersForm.setValue(ids);
      this.setCheckboxAll(this.users, selectedUsers);
      this.updateDisplayValue(ids);
    });

    this.store.select(getCallHistoryPageSelector).subscribe(params => {
      this.filters = params;
    });

    this.setCheckboxAll(this.users, []);
    this.liveUpdateSelectedValue();
  }

  addFilter(type, value) {
    this.callHistoryService.addFilter(type, value, this.callHistoryService.getPagerIndexReset(this.filters.pager));
  }

  getUserName(user) {
    return user.name ? (user.surname ? `${user.name} ${user.surname}` : user.name) : user.username;
  }

  toggleAllUsersSelect() {
    this.toggleSelectAllUsers.next();
    if (this.allUsersSelected) {
      this.usersSelector.options.forEach((item: MatOption, index: number) => {
        item.select();
      });
    } else {
      this.usersSelector.options.forEach((item: MatOption) => item.deselect());
    }
  }

  setCheckboxAll(allUsers: UserSimplified[], selectedUsers: UserSimplified[]) {
    this.allUsersSelected = this.callHistoryService.setCheckboxAll(allUsers, selectedUsers).allSelected;
    this.indeterminate = this.callHistoryService.setCheckboxAll(allUsers, selectedUsers).indeterminate;
  }

  // avoid calculating displayed label on every re-render
  private liveUpdateSelectedValue() {
    this.selectedUsersForm.valueChanges.subscribe((selectedIds: number[]) => {
      this.updateDisplayValue(selectedIds);
    });
  }

  private updateDisplayValue(selectedIds: number[]) {
    if (!selectedIds || !selectedIds.length) {
      this.displayLabel = '';
      return;
    }
    const firstUser = this.users.find(({ id }) => id === selectedIds[0]);
    this.displayLabel = this.getUserName(firstUser);
  }
}
